import { ValidationResult } from "@forms/helpers/validationHelpers";
import React from "react";

export default function ValidationMessage(validationResult: ValidationResult) {
    return <>{validationResult.message && <div className="itf-invalid-answer">{validationResult.message}</div>}</>;
}
